import { apiFetch } from "./client";
import { canonicalStockyPublicBigIntId } from "./stocky_public_ids";

export interface LocationOption {
  /** Canonical decimal `locations.id`; never round-trip through Number. */
  id: string;
  /** Canonical decimal Shopify location identity. */
  shopify_location_id: string;
  name: string;
  /**
   * プランの拠点数上限の内側か。backend は上限超過の拠点も**隠さず** false を付けて
   * 返す（隠すと「なぜ選べないのか」を画面が説明できない）。選択肢にするときは
   * `toLocationSelectOptions` を通して disabled + 理由表示にする。
   * optional なのはデプロイスキュー対策（旧レスポンスには無い＝選択可として扱う）。
   */
  allowed?: boolean;
}

function normalizeLocationOption(value: unknown): LocationOption {
  if (value === null || typeof value !== "object") {
    throw new TypeError("location response is invalid");
  }
  const location = value as Omit<
    LocationOption,
    "id" | "shopify_location_id"
  > & {
    id: unknown;
    shopify_location_id: unknown;
  };
  return {
    ...location,
    id: canonicalStockyPublicBigIntId(location.id),
    shopify_location_id: canonicalStockyPublicBigIntId(
      location.shopify_location_id,
    ),
  };
}

/** このストアのロケーション一覧（配送先ピルの選択肢用）。名前昇順。 */
export async function listLocations(): Promise<LocationOption[]> {
  const result = await apiFetch<unknown>("/api/locations");
  if (!Array.isArray(result)) {
    throw new TypeError("location list response is invalid");
  }
  return result.map(normalizeLocationOption);
}
